import React from 'react';
import { Helmet } from 'react-helmet';
import questionsData from './questions.json';
import './About.css';

const About = () => {
  const pageUrl = 'https://jerryevanoff.com/about';
  const pageTitle = 'About Jerry Evanoff | Mystery Author';
  const pageDescription =
    'Learn more about Jerry Evanoff, author of the Sam Norris Murder Mystery Series, including his writing life, books, influences, and personal background.';

  const personSchema = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: 'Jerry Evanoff',
    url: pageUrl,
    image: 'https://jerryevanoff.com/images/jerry-evanoff.jpg',
    jobTitle: 'Author',
    description:
      'Jerry Evanoff is the author of the Sam Norris Murder Mystery Series, featuring a tech-savvy programmer and amateur sleuth solving modern whodunit mysteries.',
    sameAs: [
      'https://jerryevanoff.com',
      'https://jerryevanoffauthor.substack.com/'
    ],
    knowsAbout: [
      'murder mystery novels',
      'amateur sleuth mysteries',
      'modern whodunits',
      'soft-boiled mysteries',
      'Agatha Christie-style mysteries',
      'science fiction',
      'time travel fiction'
    ],
    authorOf: {
      '@type': 'BookSeries',
      name: 'Sam Norris Murder Mystery Series',
      genre: [
        'Murder mystery',
        'Amateur sleuth mystery',
        'Whodunit',
        'Soft-boiled mystery'
      ]
    }
  };

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>

        <meta name="description" content={pageDescription} />

        <meta
          name="keywords"
          content="Jerry Evanoff, mystery author, Sam Norris Murder Mystery Series, amateur sleuth mystery author, modern whodunit author, soft-boiled mystery author, Agatha Christie-style mystery"
        />

        <meta name="author" content="Jerry Evanoff" />

        <link rel="canonical" href={pageUrl} />

        <meta property="og:type" content="profile" />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:site_name" content="Jerry Evanoff" />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />

        <script type="application/ld+json">
          {JSON.stringify(personSchema)}
        </script>
      </Helmet>

      <div className="about">
        <div className="about-container">
          <h1 className="about-title">About Me</h1>

          <div className="special-note">
            <p>
              I asked ChatGPT to come up with a bunch of questions about my normal life, my writing life, and other random questions.
              This is what it came up with.
            </p>
          </div>

          {questionsData.categories.map((category, categoryIndex) => (
            <div key={categoryIndex} className="category">
              <h2 className="category-title">{category.title}</h2>

              {category.questions.map((question, questionIndex) => (
                <div key={questionIndex} className="question">
                  <h3 className="question-title">{question.question}</h3>
                  <p className="question-answer">{question.answer}</p>
                </div>
              ))}

              {categoryIndex < questionsData.categories.length - 1 && (
                <div className="category-space" />
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default About;